import { TextProps } from '@chakra-ui/react';
import React from 'react';

import { CmText } from './CmText';

export const CmErrorText: React.FC<TextProps> = ({ children, ...rest }) => {
  return (
    <CmText fontSize="sm" color="red" {...rest}>
      {children}
    </CmText>
  );
};
